<template>
  <div>
    <v-data-table
      :headers="fejlec"
      :items="sablonok"
      >
      <template v-slot:top>
        <v-row>
          <v-col cols="12" sm="3"><h2>Sablon hozzáadása</h2></v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              rounded
              outlined
              prepend-inner-icon="fa-magic"
              label="Sablon neve"
              v-model="dialogusok.ujsablon.nev"
            />
          </v-col>
          <v-col cols="12" sm="1">
            <v-tooltip top v-if="dialogusok.ujsablon.nev">
              <template v-slot:activator="{on, attrs}">
                <v-btn
                  fab
                  color="success"
                  v-on="on"
                  v-bind="attrs"
                  @click="hozzaadas"
                ><v-icon>fa-plus</v-icon></v-btn>
              </template>
              Sablon hozzáadása
            </v-tooltip>

          </v-col>
        </v-row>
      </template>
      <template v-slot:item.diakmodosithatja="{item}">
        <v-icon v-if="item.diakmodosithatja==1" color="success">fa-check</v-icon>
        <v-icon v-else color="red accent-4">fa-times</v-icon>
      </template>
      <template v-slot:item.muveletek="{item}">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-bind="attrs" v-on="on" color="success" @click="alkalmazdialogus(item.id)"><v-icon>fa-magic</v-icon></v-btn>
          </template>
          Alkalmaz
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-bind="attrs" v-on="on" color="info" :to="{name: 'szilenciumibejegyzessablon', params: {id: item.id}}"><v-icon>fa-edit</v-icon></v-btn>
          </template>
          Szerkesztés
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn  icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(item.id)"><v-icon>fa-trash</v-icon></v-btn>
          </template>
          Törlés
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
        v-model="dialogusok.torles.mutat"
        persistent
        max-width="600px"
    >

        <v-card>
          <v-card-title>
            <span class="headline" >Sablon törlése</span>
          </v-card-title>
          <v-card-text>
            <p>Biztosan szeretné törölni a(z) "{{sablonok.find(s => s.id==dialogusok.torles.sablonid)?sablonok.find(s => s.id==dialogusok.torles.sablonid).nev:""}}" nevű sablont?</p>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialogusok.torles.mutat=false"
            >
              Mégsem<v-icon>fa-times</v-icon>
            </v-btn>
            <v-btn
              color="red accent-4"
              text
              @click="torles"
            >
              Törlés<v-icon>fa-trash</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogusok.alkalmaz.mutat"
        persistent
        max-width="600px"
    >

        <v-card>
          <v-card-title>
            <span class="headline" >Sablon alkalmazása</span>
          </v-card-title>
          <v-card-text>
            <p>{{sablonok.find(s => s.id==dialogusok.torles.sablonid)?sablonok.find(s => s.id==dialogusok.torles.sablonid).nev:""}}</p>
              <v-menu
                ref="menu"
                v-model="dialogusok.alkalmaz.datumvalasztomutat"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="dialogusok.alkalmaz.napok"
                    multiple
                    chips
                    small-chips
                    rounded
                    outlined
                    label="Napok"
                    prepend-inner-icon="fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-combobox>
                </template>
                <v-date-picker
                  v-model="dialogusok.alkalmaz.napok"
                  :allowed-dates="hcsnapok"
                  first-day-of-week="1"
                  multiple
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="dialogusok.alkalmaz.datumvalasztomutat = false"
                  >
                    Ok
                  </v-btn>

                </v-date-picker>
              </v-menu>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialogusok.alkalmaz.mutat=false"
            >
              Mégsem<v-icon>fa-times</v-icon>
            </v-btn>
            <v-btn
              color="success"
              text
              @click="alkalmaz()"
            >
              Alkalmaz<v-icon>fa-magic</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <template>
  		<v-snackbar
  		 v-model="snackbar.megnyit"
  		>
  		 {{ snackbar.szoveg }}
  		 <v-btn
  			 color="pink"
  			 text
  			 @click="snackbar.megnyit = false"
  		 >
  			 Bezár
  		 </v-btn>
  		</v-snackbar>
	</template>
  </div>
</template>


<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        fejlec: [
          {
            text: "Sablon",
            value: "nev",
            align: "center",
            sortable: false,
            groupable: false,
            filterable: false
          },
          {
            text: "A sablon által jelölt szilenciumokat a diák módosíthatja",
            value: "diakmodosithatja",
            align: "center",
            sortable: false,
            groupable: false,
            filterable: false
          },
          {
            text: "Műveletek",
            value: "muveletek",
            align: "center",
            sortable: false,
            groupbale: false,
            filterable: false
          }
        ],
        dialogusok: {
          torles: {
            sablonid: null,
            mutat: false
          },
          ujsablon: {
            nev: ""
          },
          alkalmaz: {
            mutat: false,
            sablonid: null,
            napok: [],
            datumvalasztomutat: false
          }

        },
        sablonok: []
      }
		},
		computed: {

		},
		watch: {

		},
		methods: {
      alkalmaz: function() {
        this.axios.post(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/"+this.dialogusok.alkalmaz.sablonid+"/alkalmaz", {napok: this.dialogusok.alkalmaz.napok}).then(response => {
          if(response.data.bejelentkezve==false) this.kijelentkezes();
          if(response.data.ok) {
            this.dialogusok.alkalmaz.mutat=false;
            this.snackbar.szoveg="Az alkalmazás sikeresen megtörtént."
            this.snackbar.mutat=true;
          } else {
            this.snackbar.szoveg="Az alkalmazás hibába ütközött: "+response.data.hiba;
            this.snackbar.mutat=true;
          }
        })
      },
      hozzaadas: function() {
        this.axios.post(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/", {nev: this.dialogusok.ujsablon.nev}).then(response => {
          if(response.data.bejelentkezve==false) this.kijelentkezes();
          if(response.data.ok) {
            this.sablonok.push({nev: this.dialogusok.ujsablon.nev, id: response.data.id, diakmodosithatja: 0})
            this.dialogusok.ujsablon.nev="";
            this.snackbar.szoveg="A hozzáadás sikeresen megtörtént."
            this.snackbar.mutat=true;
          } else {
            this.snackbar.szoveg="A hozzáadás hibába ütközött: "+response.data.hiba;
            this.snackbar.mutat=true;
          }
        })
      },
      torles: function() {
        this.axios.delete(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/"+this.dialogusok.torles.sablonid+"/")
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
                      this.sablonok.splice(this.sablonok.findIndex(s => s.id==this.dialogusok.torles.sablonid),1);
                      this.dialogusok.torles.mutat=false;
                      this.snackbar.szoveg="A törlés sikeresen végbement."
                      this.snackbar.mutat=true;
                    }
                    else {
                      this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba;
                      this.snackbar.mutat=true;
                    }
                  })
      },
      torlesdialogus: function(sablonid){
        this.dialogusok.torles.sablonid=sablonid
        this.dialogusok.torles.mutat=true;
      },
      alkalmazdialogus: function(sablonid) {
        this.dialogusok.alkalmaz.sablonid=sablonid;
        this.dialogusok.alkalmaz.mutat=true;
      },
      hcsnapok: nap => new Date(Date.parse(nap)).getDay()>=1&&new Date(Date.parse(nap)).getDay()<=4,
		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"szilenciumibejegyzessablonok").then((response) => {
				if(response.data.ok){
          this.sablonok=response.data.sablonok;
        }
        if(response.data.bejelentkezve== false) this.kijelentkezes();
			})
		}
	}
</script>
